import { ChangeDetectionStrategy, Component, OutputEmitterRef, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'mp-create-ticket-button',
  templateUrl: './create-ticket-button.component.html',
  styleUrl: './create-ticket-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, MatIcon],
})
export class CreateTicketButtonComponent {
  readonly createTicketButtonClick: OutputEmitterRef<void> = output<void>();

  onCreateTicketButtonClick(): void {
    this.createTicketButtonClick.emit();
  }
}
